import { render, staticRenderFns } from "./ChartingFavoriteColorPicker.vue?vue&type=template&id=1d2e0312&scoped=true&"
import script from "./ChartingFavoriteColorPicker.vue?vue&type=script&lang=js&"
export * from "./ChartingFavoriteColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./ChartingFavoriteColorPicker.vue?vue&type=style&index=0&id=1d2e0312&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2e0312",
  null
  
)

export default component.exports